/* eslint-disable import/prefer-default-export */

export const INDEX_CHANGED = 'INDEX_CHANGED';
